import { useEffect, useState } from 'react';
import { Course } from "../model/course";
import { UserCertification} from "../model/certification";
import { AppDispatch, RootState } from "../reducers/store";
import { AlertView } from './alert';

import { useDispatch, useSelector } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { User } from '../model/user';
import { Program } from '../model/program';
import { UserCertCourseRow } from './usercertcourse';
import { Tooltip, TableSortLabel } from '@mui/material';
import { sortCurrentUserCertifications } from '../reducers/certificationSlice';
import { sortCurrentGroupUsers } from '../reducers/userSlice';

export const UserCertificationView = () => {   
    const dispatch: AppDispatch = useDispatch();
    const [errorMessage, setError] = useState<string | null>(null);

    const [emailAscending, setEmailAscending] = useState(true);
    const [firstNameAscending, setFirstNameAscending] = useState(true);
    const [lastNameAscending, setLastNameAscending] = useState(true);
    const [departmentAscending, setDepartmentAscending] = useState(true);
    
    const currentProgram: Program | null = useSelector((state: RootState) => state.programs.currentProgram);
    const currentGroupUsers: User[] = useSelector((state: RootState) => state.users.currentGroupUsers);
    const allCourses: Course[] = useSelector((state: RootState) => state.courses.courses);
    const currentUserCertifications: UserCertification[] | null = useSelector((state: RootState) => state.certifications.currentUserCertifications);
    const currentCourses = allCourses.filter((course) => course.programId == currentProgram?.id)

    const findUser = (userId: string): User | undefined => currentGroupUsers.find(u => u.id === userId);

    let startedUserIds: string[] = currentUserCertifications?.map(certification => certification.userId) ?? [];
    let usersWithoutData = currentGroupUsers.filter(user => !startedUserIds.includes(user.id));

    useEffect(() => {
        setLastNameAscending(false)
        dispatch(sortCurrentUserCertifications({ascending: true, field: "lastName"}));
        dispatch(sortCurrentGroupUsers({ascending: true, field: "lastName"}));
    }, []);

    return (
        <div style={{padding: 16}}>
            <AlertView error={errorMessage}/>
            <Typography sx={{ marginBottom: 2 }} align='left'>Certification progress</Typography>
            <TableContainer component={Paper} sx={{ marginBottom: 5 }} >
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>
                                <Tooltip title="Certified means the user has passed all assessment quizzes in the program that have a minimum pass threshold">
                                    <span style={{ cursor: 'help' }}>
                                        Certified
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell>Passed</TableCell>
                            <TableCell width={250}>
                                <TableSortLabel
                                    active={true}
                                    direction={emailAscending ? 'asc' : 'desc'}
                                    onClick={() => {
                                        setEmailAscending(!emailAscending)
                                        dispatch(sortCurrentUserCertifications({ascending: emailAscending, field: "email"}))
                                        dispatch(sortCurrentGroupUsers({ascending: emailAscending, field: "email"}))
                                    }}
                                >
                                    Email
                                </TableSortLabel>
                            </TableCell>
                            <TableCell width={200}>
                                <TableSortLabel
                                    active={true}
                                    direction={firstNameAscending ? 'asc' : 'desc'}
                                    onClick={() => {
                                        setFirstNameAscending(!firstNameAscending)
                                        dispatch(sortCurrentUserCertifications({ascending: firstNameAscending, field: "firstName"}))
                                        dispatch(sortCurrentGroupUsers({ascending: firstNameAscending, field: "firstName"}))
                                    }}
                                >
                                    First Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell width={200}>
                                <TableSortLabel
                                    active={true}
                                    direction={lastNameAscending ? 'asc' : 'desc'}
                                    onClick={() => {
                                        setLastNameAscending(!lastNameAscending)
                                        dispatch(sortCurrentUserCertifications({ascending: lastNameAscending, field: "lastName"}))
                                        dispatch(sortCurrentGroupUsers({ascending: lastNameAscending, field: "lastName"}))
                                    }}
                                >
                                    Last Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>
                                <TableSortLabel
                                    active={true}
                                    direction={departmentAscending ? 'asc' : 'desc'}
                                    onClick={() => {
                                        setDepartmentAscending(!departmentAscending)
                                        dispatch(sortCurrentUserCertifications({ascending: departmentAscending, field: "department"}))
                                        dispatch(sortCurrentGroupUsers({ascending: departmentAscending, field: "department"}))
                                    }}
                                >
                                    Department
                                </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                        currentUserCertifications?.map((userCert) => (
                            userCert.userEmail ? 
                                <UserCertCourseRow 
                                    key={userCert.userId} 
                                    userCert={userCert} 
                                    courses={currentCourses}
                                    firstName={findUser(userCert.userId)?.firstName ?? ""}
                                    lastName={findUser(userCert.userId)?.lastName ?? ""}
                                    department={findUser(userCert.userId)?.department ?? ""}
                                />:
                                <></>
                        ))
                    }
                    </TableBody>
                </Table>
            </TableContainer>
            
            {
                currentProgram?.clientName != "Public" ? (
                    <>
                        <Typography sx={{ marginBottom: 2 }} align='left'>No certification data</Typography>
                        <TableContainer component={Paper}>
                            <Table aria-label="regular table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell/>
                                        <TableCell width={250}>
                                            <TableSortLabel
                                                active={true}
                                                direction={emailAscending ? 'asc' : 'desc'}
                                                onClick={() => {
                                                    setEmailAscending(!emailAscending)
                                                    dispatch(sortCurrentUserCertifications({ascending: emailAscending, field: "email"}))
                                                    dispatch(sortCurrentGroupUsers({ascending: emailAscending, field: "email"}))
                                                }}
                                            >
                                                Email
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell width={200}>
                                            <TableSortLabel
                                                active={true}
                                                direction={firstNameAscending ? 'asc' : 'desc'}
                                                onClick={() => {
                                                    setFirstNameAscending(!firstNameAscending)
                                                    dispatch(sortCurrentUserCertifications({ascending: firstNameAscending, field: "firstName"}))
                                                    dispatch(sortCurrentGroupUsers({ascending: firstNameAscending, field: "firstName"}))
                                                }}
                                            >
                                                First Name
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell width={200}>
                                            <TableSortLabel
                                                active={true}
                                                direction={lastNameAscending ? 'asc' : 'desc'}
                                                onClick={() => {
                                                    setLastNameAscending(!lastNameAscending)
                                                    dispatch(sortCurrentUserCertifications({ascending: lastNameAscending, field: "lastName"}))
                                                    dispatch(sortCurrentGroupUsers({ascending: lastNameAscending, field: "lastName"}))
                                                }}
                                            >
                                                Last Name
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={true}
                                                direction={departmentAscending ? 'asc' : 'desc'}
                                                onClick={() => {
                                                    setDepartmentAscending(!departmentAscending)
                                                    dispatch(sortCurrentUserCertifications({ascending: departmentAscending, field: "department"}))
                                                    dispatch(sortCurrentGroupUsers({ascending: departmentAscending, field: "department"}))
                                                }}
                                            >
                                                Department
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        usersWithoutData.map((user) => (
                                            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                <TableCell width={250}></TableCell>
                                                <TableCell width={250}>{user.email}</TableCell>
                                                <TableCell>{user.firstName}</TableCell>
                                                <TableCell>{user.lastName}</TableCell>
                                                <TableCell>{user.department}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ): <></>
            }
        </div>
    );
}